
export default function ProgressJourney() {
  const steps = [
    {
      icon: 'ri-play-circle-line',
      title: 'Start a Microcourse',
      description: 'Pick a 15-minute lesson on any topic — from AI basics to creative writing.',
      gradient: 'from-[#304FFE] to-[#5B9FED]',
    },
    {
      icon: 'ri-trophy-line',
      title: 'Earn a Badge',
      description: 'Complete it and unlock a verified badge that proves your new skill.',
      gradient: 'from-[#7C4DFF] to-[#B794F6]',
    },
    {
      icon: 'ri-stack-line',
      title: 'Stack Your Skills',
      description: 'Collect badges to build pathways toward degrees, bootcamps, or career goals.',
      gradient: 'from-[#FF6B9D] to-[#FFA726]',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Unlock Your Future',
      description: 'Turn micro-progress into major achievements — one badge at a time.',
      gradient: 'from-[#00BFA5] to-[#00E676]',
    },
  ];

  return (
    <section className="py-28 px-6 lg:px-12 relative overflow-hidden">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#304FFE]/[0.08] via-transparent to-[#7C4DFF]/[0.08]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      </div>

      {/* Floating decorative elements */}
      <div className="absolute top-1/4 right-[10%] w-64 h-64 bg-gradient-to-br from-[#304FFE]/20 to-[#7C4DFF]/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-1/4 left-[15%] w-48 h-48 bg-gradient-to-br from-[#7C4DFF]/15 to-[#304FFE]/15 rounded-full blur-3xl animate-pulse delay-1000"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl lg:text-6xl font-bold text-[#1A1F36] mb-6">
            Microlearning that unlocks your future
          </h2>
          <p className="text-2xl text-gray-600 max-w-4xl mx-auto font-light leading-relaxed">
            Every microcourse you complete earns you a verified badge. Stack them to unlock pathways toward degrees, bootcamps, and career opportunities.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 border border-gray-100 relative overflow-hidden group"
            >
              {/* Subtle glow effect */}
              <div className={`absolute inset-0 bg-gradient-to-br ${step.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>

              {/* Content */}
              <div className="relative z-10">
                {/* Step number */}
                <div className="text-sm font-bold text-gray-400 mb-4">
                  Step {index + 1}
                </div>

                {/* Icon */}
                <div className={`w-16 h-16 bg-gradient-to-br ${step.gradient} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg`}>
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-[#1A1F36] mb-3">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
